
export default class AgentAnnouncementCategory {

  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.name = jsonResponse["categoryName"];
  }
}
